<template>
  <CModal
    @mtdclosemodal="mtdClose"
    :show="boo_modal"
    :close-on-backdrop="false"
    :centered="false"
    :title="title"
    :size="'xl'"
    :btn_cancel="true"
    :btn_ok="true"
    :booTitile="true"
    :fullScreen="false"
  >
    <div class="row d-flex">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <label class="mb-3 mt-2">Nombre de examen</label>
        <div class="input-group input-group-sm">
          <div class="input-group-text">
            <span style="font-size: 20px; border: none">
              <i class="fa fa-briefcase-medical"></i>
            </span>
          </div>
          <input
            type="text"
            class="form-control"
            placeholder="Nombre"
            v-model="name"
            disabled
          />
        </div>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12">
        <label class="mb-3 mt-2">Analisis</label>
        <div class="input-group input-group-sm">
          <div class="input-group-text">
            <span style="font-size: 20px; border: none">
              <i class="fa fa-briefcase-medical"></i>
            </span>
          </div>
          <input
            type="text"
            class="form-control"
            placeholder="Nombre"
            v-model="item.analisis"
          />
        </div>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12">
        <label class="mb-3 mt-2">Unid</label>
        <div class="input-group input-group-sm">
          <div class="input-group-text">
            <span style="font-size: 20px; border: none">
              <i class="fa fa-briefcase-medical"></i>
            </span>
          </div>
          <input
            type="text"
            class="form-control"
            placeholder="Unid"
            v-model="item.unid"
          />
        </div>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12">
        <label class="mb-3 mt-2">Rango referencial</label>
        <div class="input-group input-group-sm">
          <div class="input-group-text">
            <span style="font-size: 20px; border: none">
              <i class="fa fa-briefcase-medical"></i>
            </span>
          </div>
          <input
            type="text"
            class="form-control"
            placeholder="Rango(referencial)"
            v-model="item.rango"
          />
        </div>
      </div>

      <!-- Metodo + botón + en misma fila -->
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12">
        <label class="mb-3 mt-2">Metodo</label>
        <div class="input-group input-group-sm">
          <div class="input-group-text">
            <span style="font-size: 20px; border: none">
              <i class="fa fa-briefcase-medical"></i>
            </span>
          </div>
          <input
            type="text"
            class="form-control"
            placeholder="Metodo"
            v-model="item.metodo"
          />
          <button
            class="btn btn-success btn-sm"
            :disabled="!formValido || saving"
            @click="mtdAddItem"
            title="Agregar"
          >
            <i class="fas fa-plus"></i>
          </button>
        </div>
      </div>

      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2">
        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th>#</th>
              <th>Analisis</th>
              <th>Unidad</th>
              <th>Rango</th>
              <th>Metodo</th>
              <th>Accion</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="localResults.length == 0">
              <td colspan="6" class="text-center">No hay registros</td>
            </tr>
            <tr v-for="(result, index) in localResults" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ result.analisis }}</td>
              <td>{{ result.unid }}</td>
              <td>{{ result.rango }}</td>
              <td>{{ result.metodo }}</td>
              <td class="text-center">
                <button
                  class="btn btn-sm btn-danger"
                  @click="mtdDeleteItem(result, index)"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <template #footer>
      <button class="btn btn-secondary btn-sm" @click="mtdClose">
        Cerrar
      </button>
      &nbsp;
    </template>
    <SweetAlert :swal="swal" ref="SweetAlert" />
  </CModal>
</template>

<script>
import CModal from "../../shared/modals/CModal.vue";
import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";
import { mapActions } from "vuex";

export default {
  name: "c-maintenance-modal-servicioEsp",
  components: { CModal, SweetAlert },
  data() {
    return {
      swal: null,
      name: "",
      localResults: [],
      saving: false,
      item: {
        subsub_category_id: "",
        analisis: "",
        resultado: "",
        unid: "",
        rango: "",
        metodo: "",
      },
    };
  },
  watch: {
    results: {
      handler(newVal) {
        this.name = this.nombre;
        this.item.subsub_category_id = this.id;
        this.localResults = newVal ? [...newVal] : [];
      },
      immediate: true,
    },
  },
  props: {
    title: String,
    boo_modal: Boolean,
    nombre: String,
    results: {
      type: Array,
      default: () => [],
    },
    id: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    formValido() {
      return (
        this.item.analisis.trim() !== "" &&
        this.item.unid.trim()     !== "" &&
        this.item.rango.trim()    !== "" &&
        this.item.metodo.trim()   !== ""
      );
    },
    cpButton() {
      return false;
    },
  },
  methods: {
    ...mapActions(["get", "post"]),

    mtdClose() {
      this.name = "";
      this.localResults = [];
      this.item = {
        subsub_category_id: "",
        analisis: "",
        resultado: "",
        unid: "",
        rango: "",
        metodo: "",
      };
      this.$emit("closeModal");
    },

    mtdResetItem() {
      this.item = {
        subsub_category_id: this.id,
        analisis: "",
        resultado: "",
        unid: "",
        rango: "",
        metodo: "",
      };
    },

    /** Guarda en BD y añade a la tabla */
    async mtdAddItem() {
      if (!this.formValido || this.saving) return;
      this.saving = true;
      try {
        const response = await this.post({
          url:    this.$store.getters.get__url + "/laboratory/resultitem",
          token:  this.$store.getters.get__token,
          params: { ...this.item },
        });
        this.localResults.push(response.data);
        this.mtdResetItem();
        this.$refs.SweetAlert.showSuccess("Ítem registrado correctamente");
      } catch (e) {
        this.$refs.SweetAlert.showError(e);
      } finally {
        this.saving = false;
      }
    },
    mtdDeleteItem(result, index) {
      this.$refs.SweetAlert.showConfirmSimple2(
        "",
        "¿Eliminar este ítem?",
        "warning",
        "Eliminar"
      ).then((res) => {
        if (res.value) {
          this.post({
            url:    this.$store.getters.get__url + "/laboratory/resultitem/delete/" + result.id,
            token:  this.$store.getters.get__token,
            params: { },
          })
            .then(() => {
              this.localResults.splice(index, 1);
              this.$refs.SweetAlert.showSuccess("Ítem eliminado correctamente");
            })
            .catch((e) => {
              this.$refs.SweetAlert.showError(e);
            });
        }
      });
    },
  },
};
</script>